/**
 * Do jQuery POST ajax request and return plain Promise.
 * In case of error the Promise will be rejected with error description as string
 */
export function post<T extends object>(settings: JQuery.UrlAjaxSettings): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    $.post(settings)
      .done((result) => {
        resolve(result as T);
      })
      .fail((xhr, textStatus, errorThrown) => {
        let reason = `HTTP POST error.`;
        if (settings.url) {
          reason += ` URL: "${settings.url}".`;
        }
        if (xhr.status || xhr.statusText || textStatus) {
          reason += ` Status: "${textStatus} ${xhr.status} ${xhr.statusText}".`;
        }
        if (errorThrown) {
          reason += ` Error: "${errorThrown}".`;
        }
        if (xhr.responseText) {
          reason += ` Response: "${xhr.responseText}".`;
        }
        reject(reason);
      });
  });
}
